import React from "react";
import { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import '../assets/styles/Images.scss';
import { toast } from "react-toastify";
import { ArchiveImageApi, getRawPoleImage, setImagePriority } from '../services/api';
import { getRole } from "../services/authenticationService";

interface ImgFiles {
	imgName: string;
	priority: string;
}

type priorityArray = number;

interface Image {
	name?: string;
	priority?: string;
	isDelete?: string
}

export interface Props {
	imageFiles: ImgFiles[];
	image: Image;
	id: unknown | string;
	show: boolean;
	resetImages: (data, image) => void;
	onHide: () => void;
	highPriority: priorityArray[];
	refreshPoleData: () => void;
}

const ImageModal: React.FC<Props> = (props: Props) => {
	const [rawImage, setRawImage] = useState(null);
	const [blob, setBlob] = useState(null);
	const [priority, setPriority] = useState("null");
	const [imgArray, setImgArray] = useState([]);
	const { imageFiles, image, id, resetImages } = props;

	useEffect(() => {
		if (!props.show) return;
		else fetchImage();
	}, [props.show]);

	const fetchImage = () => {
		setImgArray(imageFiles);
		getRawPoleImage(id, image.name, true)
			.then(res => res.blob()) //Gets the response and returns it as a blob
			.then(response => {
				const objectURL = window.URL.createObjectURL(response);
				setPriority(image.priority);
				setRawImage(objectURL);
				setBlob(response);
			}).catch(err => {
				console.error(err);
			})
	}

	const toggleRadioButton = (data) => {  //set priority to image by radio button response
		if (priority === "null") {
			setPriority(data);
			setPriorityApi(data);
		}
		else if (priority === data) {
			setPriority("null");
			setPriorityApi("null");
		}
	}

	const setPriorityApi = (data) => {
		imgArray.find(({ imgName }) => imgName == image.name).priority = data;
		const params = { poleId: id, images: JSON.stringify(imgArray) };
		//Priority api call
		setImagePriority(params).then(() => {
			resetImages(data, image.name);
			if (data === "null") return toast.success("Image un-marked from high priority");
			else return toast.success("Image marked as high priority");
		}).catch(err => {
			console.error(err);
			toast.error(err);
		})

	}

	const closeModal = () => {
		props.onHide();
		setRawImage(null);
	}

	const downloadImage = async () => {
		const href = await URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = href;
		link.download = image.name;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}

	const handleDeleteOrRestoreImage = () => {
		const params = {
			poleId: id,
			imageName: image.name,
			isArchive: !image.isDelete,
		}
		console.log( params )
		ArchiveImageApi(params).then(response => {
			closeModal();
			props.refreshPoleData();
			toast.success(response);
		}).catch(err => {
			toast.error(err);
		})
	};

	return (
		<>
			{rawImage &&
				<Modal  show={props.show} onHide={props.onHide} className="slider-modal mt-2" data-testid="modal" backdropClassName="slider-modal"
					centered >
					<Modal.Body >
						<div className="text-center img-block border">
							<img className="img-fluid" data-testid="img" src={rawImage} alt="" />
						</div>
						<div className="row d-flex justify-content-end mt-2 ps-2 pe-2">
							{getRole() === 'Admin' && props.highPriority[0] > 0 &&
								<div className="col-auto form-check form-switch form-check-inline p-0 mt-1">
									<label className="form-check-label ">High Priority</label>
									<input className="form-check-input float-end pointer ms-2" defaultChecked={priority != 'null'}
										type="checkbox" role="switch" data-testid="toggle-btn" onClick={() => toggleRadioButton('high')} />
								</div>
							}
							
							{(getRole() === 'Admin' || getRole() === 'Maintainer') &&
								<div className="col-auto align-self-center">
									{props.image.isDelete ?
										<Button className='btn btn-danger text-5 pointer text-center' data-testid="delete-btn" onClick={() => handleDeleteOrRestoreImage()}>Restore
											<Icon.ArrowClockwise className='delete ms-2' />
										</Button> :
										<Button className='btn btn-danger text-5 pointer text-center' data-testid="delete-btn" onClick={() => handleDeleteOrRestoreImage()}>ARCHIVE
											<Icon.Trash className='delete ms-2' />
										</Button>
										}
								</div>
							}

							<div className="col-auto align-self-center">
								<Button className='btn btn-primary text-5 pointer text-center' data-testid="download-btn" onClick={downloadImage}>DOWNLOAD
									<Icon.Download className='download ms-2' />
								</Button>
							</div>
						</div>
					</Modal.Body>
				</Modal >
			}
		</>
	);
};

export default ImageModal;
